import styled from "styled-components";

export const List = styled.ul`
  display: flex;
  @media (min-width: ${({ theme }: any) => theme.mobileBp}) {
    flex-wrap: wrap;
    li {
      &:nth-child(1),
      &:nth-child(2) {
        margin-bottom: 40px;
        font-size: 20px;
        font-weight: 500;
      }
      &:nth-child(2) {
        width: 66.666%;
      }
      width: 33.333%;
      padding-right: 5px;
      margin-bottom: 20px;
    }
  }
  @media (max-width: ${({ theme }: any) => theme.mobileBp}) {
    flex-direction: column;
    a {
      display: flex;
      justify-content: space-between;
      padding: 10px;
      padding-left: 5px;
      border-bottom: ${({ theme }: any) => theme.border.light};
    }
  }
`;
export const SearchWrap = styled.div`
  margin-bottom: 15px;
  position: relative;
  input {
    width: 100%;
    flex: 1;
    border: none;
    box-shadow: none;
    padding: 30px 20px;
    padding-right: 35px !important;
    background: transparent;
    color: var(--font-color-main);
    outline: none;
    transition: border-color 0.25s ease;
    border-bottom: ${({ theme }: any) => theme.border.light};
    :focus {
      border-color: var(--color-primary);
    }
    ::placeholder {
      color: var(--font-color-accent);
    }
  }
  @media (max-width: ${({ theme }: any) => theme.mobileBp}) {
    input {
      padding: 10px;
    }
    margin-bottom: 7px;
  }
`;
